// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__YTzh4","file":"styles_file__2bqR4"};